
























import { Component, Vue, Watch } from 'vue-property-decorator';
import { APP_CONFIG } from '@/config/app-config';

@Component
export default class Breadcrumb extends Vue {
    private breadcrumblist: any = [];

    @Watch('$route', { immediate: true, deep: true })
    private getBreadcrumb() {
        this.breadcrumblist = this.$route.matched.reduce((breadcrumbs: any, route: any) => {
            return breadcrumbs.concat((route.meta.breadcrumb || []).reduce((a: any, b: any) => {
                return a.concat(b);
            }, []));
        }, []);
    }

    get rate() {
      return this.$store.state[APP_CONFIG.stateKey.commonStore].rate;
    }

}
